export default "__VITE_ASSET__y1_8JoGo__"